import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BiArrowFromLeft,
  BiArrowFromRight,
  BiCog,
  BiUser,
} from 'react-icons/bi';

import TableauTasks from './TableauTasks/TableauTasks';
import ProfilTask from './ProfilTask/ProfilTask';
import ProfilTasks from './ProfilTasks/ProfilTasks';
import FormulaireTasks from './ProfilTasks/FormulaireTasks/FormulaireTasks';
import Bouton from '../UI/Bouton/Bouton';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';

import * as actions from '../../services/actions';
import * as indexConteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../ressources/functionJS/checkMot';
import S from './Tasks.module.scss';

const Tasks = () => {
  // State management
  const [selectedTask, setSelectedTask] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [containerIndex, setContainerIndex] = useState(null);
  const [showFullInfo, setShowFullInfo] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const dispatch = useDispatch();

  // Get functions from Redux store to check if data is loading
  const functions = useSelector((state) => state.functions?.fonctions || []);
  const isLoading = useSelector((state) => state.functions?.isLoading || false);

  // Load functions on component mount
  useEffect(() => {
    dispatch(actions.reqObtenirFonctions());
  }, [dispatch]);

  // Event handlers
  const handleTaskSelection = (taskInfo) => {
    setSelectedTask(taskInfo);
    setContainerIndex(indexConteneurInfo.profil);
    setShowInfo(true);
    setIsEditMode(false);
  };

  const handleEditTask = (taskInfo) => {
    setSelectedTask(taskInfo);
    setContainerIndex(indexConteneurInfo.ajouterForm);
    setShowInfo(true);
    setIsEditMode(true);
  };

  const toggleInfoCreator = () => {
    setShowInfo((prev) => {
      if (prev) {
        setShowFullInfo(false);
        return false;
      }
      return true;
    });
  };

  const toggleFullInfo = () => {
    setShowFullInfo((prev) => !prev);
  };

  const handleCancel = () => {
    setShowInfo(false);
    setContainerIndex(null);
    setIsEditMode(false);
  };

  const createTask = () => {
    setShowInfo(true);
    setContainerIndex(indexConteneurInfo.ajouterForm);
    setSelectedTask({});
    setIsEditMode(false);
  };

  // Redux action handlers
  const handleAddAlert = (alertType, title, body) => {
    dispatch(actions.ajouterAlerte(alertType, title, body));
  };

  const handleCreateTask = (taskForm) => {
    if (isEditMode) {
      dispatch(actions.reqModifierFunction(taskForm));
    } else {
      dispatch(actions.reqCreerFunction(taskForm));
    }
  };

  const handleDeleteTask = (taskId) => {
    dispatch(actions.reqSupprimerFunction(taskId));
  };

  // Style management
  const leftContainerStyle = [S.ConteneurCentralGauche];
  const rightContainerStyle = [S.ConteneurCentralDroite];
  const togglerClasses = [S.CommutateurInfo];

  if (showInfo && showFullInfo) {
    rightContainerStyle.push(S.ConteneurCentralDroiteFull);
    leftContainerStyle.push(S.ConteneurCentraGaucheVoid);
  } else if (showInfo && !showFullInfo) {
    rightContainerStyle.push(S.ConteneurCentralDroiteOuvert);
  } else {
    rightContainerStyle.push(S.ConteneurCentralDroiteFermer);
    leftContainerStyle.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <div className={S.ConteneurTasks}>
      <div className={leftContainerStyle.join(' ')}>
        <ProfilTask
          taskSelectionne={handleTaskSelection}
          taskEdition={handleEditTask}
          creer={createTask}
        />
      </div>
      <div className={rightContainerStyle.join(' ')}>
        <Bouton
          ajoutClass={[togglerClasses, S.expandTO].join(' ')}
          cliquer={toggleFullInfo}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <Bouton
          ajoutClass={S.expand}
          cliquer={toggleInfoCreator}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <ConteneurInformation
          selectionInfo={containerIndex}
          ajouterForm={
            <FormulaireTasks
              taskInfo={selectedTask}
              isEditMode={isEditMode}
              ajouterAlerte={handleAddAlert}
              annuler={handleCancel}
              sauvegarder={handleCreateTask}
            />
          }
          profil={
            <ProfilTasks
              infoTask={selectedTask}
              reqModifier={handleEditTask}
              reqSupprimer={handleDeleteTask}
            />
          }
        />
      </div>
    </div>
  );
};

export default Tasks;
